import React, { Component } from "react";
import { connect } from "react-redux";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTotalEmployeeStats } from "actions";
import * as Alerts from "components/elements/alerts";
import { Trans } from "react-i18next";
import i18next from "i18next";

am4core.useTheme(am4themes_animated);

class TotalEmployee extends Component {
  state = {
    statsFetched: false,
    isManager: localStorage.getItem("roles").includes("Manager"),
    error: null,
    selectedDepartment: { value: 0, label: i18next.t(10046) },
    selectedDepartmentCount: 0,
  };

  chartDiv = React.createRef();
  deptSelectCombo = React.createRef();
  chart = null;
  chartCreated = false;

  componentDidMount() {
    this.fetchStats();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.statsFetched && this.chartCreated === false) {
      this.allDepTotalEmpChart(0, i18next.t(10046));
      this.chartCreated = true;
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
    console.log(err);
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      statsFetched: true,
      totalEmployeeCount: this.props.stats.totalEmployeeCount,
      selectedDepartmentCount: this.props.stats.totalEmployeeCount,
    });
  };

  fetchStats = () => {
    this.props.getTotalEmployeeStats(
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  allDepTotalEmpChart = (svalue, slabel) => {
    let totalEmpCount = this.props.stats.totalEmployeeCount;
    let selectedDeptCount = totalEmpCount;
    if (svalue !== 0) {
      let department = this.props.stats.items.find((d) => d.serviceType.value === svalue);
      selectedDeptCount = department.count;
    }

    this.setState({
      selectedDepartmentCount: selectedDeptCount,
      totalEmployeeCount: totalEmpCount,
    });

    am4core.useTheme(am4themes_animated);
    // create chart
    this.chart = am4core.create(this.chartDiv.current, am4charts.GaugeChart);
    this.chart.innerRadius = am4core.percent(72);
    this.chart.paddingTop = am4core.percent(0);
    this.chart.paddingLeft = am4core.percent(0);
    this.chart.paddingRight = am4core.percent(0);
    this.chart.paddingBottom = am4core.percent(0);

    // let colorSet = new am4core.ColorSet();

    let label = this.chart.chartContainer.createChild(am4core.Label);
    label.fontSize = 32;
    label.marginTop = -50;
    label.align = "center";
    label.fill = am4core.color("#ffffff");
    label.html = '<span class="icon-icon-employee"></span>';

    let axis2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;

    let range2 = axis2.axisRanges.create();
    range2.value = 0;
    range2.endValue = 100;
    range2.axisFill.fillOpacity = 1;
    range2.axisFill.fill = am4core.color("#ffffff");
    range2.axisFill.radius = am4core.percent(117);
    range2.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    range2.grid.disabled = true;

    let range3 = axis2.axisRanges.create();
    range3.value = 70;
    range3.endValue = 100;
    range3.axisFill.fillOpacity = 1;
    range3.axisFill.fill = am4core.color("#DADADA");
    range3.axisFill.radius = am4core.percent(117);
    range3.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    range3.grid.disabled = true;

    let hand = this.chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(10);
    hand.startWidth = 0;
    hand.pin.disabled = true;
    hand.value = 0;
    hand.opacity = 0;

    hand.events.on("propertychanged", function (ev) {
      range2.endValue = ev.target.value;
      range3.value = ev.target.value;
    });

    new am4core.Animation(
      hand,
      {
        property: "value",
        to: (selectedDeptCount * 100) / totalEmpCount,
      },
      2000
    ).start();
  };

  showCombo = () => {
    let combo = this.deptSelectCombo.current;
    combo.classList.toggle("open");
  };

  handleDepartmentSelect = (value, label) => {
    this.setState({ selectedDepartment: { value: value, label: label } });
    this.allDepTotalEmpChart(value, label);
  };

  renderError = () => {
    if (this.state.error) {
      return (
        <div>
          <div style={{ width: "80%", margin: "auto" }}>
            {Alerts.RedAlert({ content: this.state.error })}
          </div>
        </div>
      );
    } else return null;
  };

  renderDepartmentCombo = () => {
    if (!this.state.statsFetched) {
      return null;
    }

    if (!this.state.isManager) return null;
    else {
      return (
        <div className="departmanSecimAlani">
          <div className="custom-select-wrapper" id="departmanSecenekleriTC">
            <div
              className="custom-select departmanSecenekleriSecili departmanSecenekleriSeciliTC"
              ref={this.deptSelectCombo}
              onClick={this.showCombo}
            >
              <div className="custom-select__trigger">
                <span>
                  {this.state.selectedDepartment.value !== 0 ? (
                    this.state.selectedDepartment.label + " "
                  ) : (
                    <>
                      <Trans desc="Tüm Departmantlar">10046</Trans>
                      <span>&nbsp;</span>
                    </>
                  )}
                </span>
                <span className="iconmford fo-icon-expand-more"></span>
              </div>
              <div
                className="custom-options departmanSecenekleriTC graphicTCoptions"
                data-id="0"
              >
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC selected"
                  data-value="all"
                  onClick={() =>
                    this.handleDepartmentSelect(0, i18next.t(10046))
                  }
                >
                  <Trans desc="Tüm Departmanlar">10046</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50022, i18next.t(10047))
                  }
                >
                  <Trans desc="Satış">10047</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50000, i18next.t(10612))
                  }
                >
                  <Trans desc="Satış Sonrası">10612</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50023, i18next.t(10048))
                  }
                >
                  <Trans desc="Servis İdari">10048</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50020, i18next.t(10049))
                  }
                >
                  <Trans desc="Mekanik">10049</Trans>
                </span>
                <span
                  className="custom-option etoGraphTypeYonetim graphicTC"
                  onClick={() =>
                    this.handleDepartmentSelect(50021, i18next.t(10050))
                  }
                >
                  <Trans desc="Kaporta/Boya">10050</Trans>
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  renderStats = () => {
    if (this.state.statsFetched) {
      return (
        <>
          <div className="calisanSayisiAlani satisDepartmaniCS">
            <div className="calisanSayisi">
              {this.state.selectedDepartmentCount}
              {this.state.selectedDepartment.value !== 0 ? (
                <sup>/{this.state.totalEmployeeCount}</sup>
              ) : null}
            </div>
            <div
              id="allDepTotalEmpChart"
              className="chartGraphic empGraphic"
              ref={this.chartDiv}
            ></div>
            <div className="clearfix"></div>
            <div
              className="borderBottomGraphicBg"
              style={{ background: "white" }}
            ></div>
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <>
        {this.props.spinner}
        <div className="bayiToplamCalisan">
          <div className="dashboardHeader">
            <div className="dashboardHeaderContent">
              <div className="calisanBaslik">
                <Trans desc="Toplam Çalışan">10007</Trans>
              </div>
              {this.renderDepartmentCombo()}
            </div>
          </div>
          <hr />
          {this.renderStats()}
          {this.renderError()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stats: state.stats.totalEmployee,
    application: state.application,
  };
};

export default connect(mapStateToProps, { getTotalEmployeeStats })(
  containsLongRunningProcess(TotalEmployee)
);
